"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareRange = exports.compareSingleValue = exports.checkRange = void 0;
const checkRange = (entity, min, max) => {
    return (min || 0) <= entity && entity <= (max || Infinity);
};
exports.checkRange = checkRange;
const compareSingleValue = ({ entity, min, max, }) => {
    return entity === null ? false : (0, exports.checkRange)(entity, min, max);
};
exports.compareSingleValue = compareSingleValue;
const compareRange = ({ minEntity, maxEntity, min, max, }) => {
    if (minEntity === null && maxEntity === null) {
        return false;
    }
    else if (minEntity !== null && maxEntity === null) {
        return (0, exports.checkRange)(minEntity, min, max);
    }
    else if (minEntity === null && maxEntity !== null) {
        return (0, exports.checkRange)(maxEntity, min, max);
    }
    else if (minEntity !== null && maxEntity !== null) {
        return (0, exports.checkRange)(minEntity, min, max) && (0, exports.checkRange)(maxEntity, min, max);
    }
    else {
        return false;
    }
};
exports.compareRange = compareRange;
//# sourceMappingURL=quantityHelpers.js.map